import { normalizeKydAudienceFilterStrings } from "@common/utils/kydAudienceMetadataFilters";

/**
 * Maps custom audience form data to the server format
 * This function handles the transformation of custom audiences from form data
 * to the format expected by the API
 */
export const mapCustomAudiencesToServerFormat = (
  customAudiences: any[]
): any[] => {
  return customAudiences.map((ca) => {
    const base = {
      id: ca.id,
      external_id: ca.external_id,
      name: ca.name,
    };

    console.log(`Custom audience ${ca.name}`, ca);

    switch (ca.audience_type) {
      case "csv":
        return {
          ...base,
          description: ca.description || "",
          file_key: ca.file_key || "",
          mapping: ca.mapping || [],
          schema_fields: ca.schema_fields || [],
          audience_type: "csv" as const,
        };
      case "kyd":
        return {
          ...base,
          description: ca.description,
          segment_id: ca.segment_id ?? null,
          genres: normalizeKydAudienceFilterStrings(ca.genres),
          artists: normalizeKydAudienceFilterStrings(ca.artists),
          lookalike:
            ca.lookalike?.name && ca.lookalike?.ratio
              ? {
                  name: ca.lookalike.name,
                  ratio: ca.lookalike.ratio,
                }
              : undefined,
          audience_type: "kyd" as const,
        };
      case "page_lookalike":
        const lookalikeRatio = ca.lookalike?.ratio || ca.lookalike_ratio || "";
        const lookalikeName = ca.lookalike?.name || ca.lookalike_name || "";
        return {
          ...base,
          description: ca.description || "",
          page_type: ca.page_type || "facebook",
          page_id: ca.page_id || "",
          page_name: ca.page_name || "",
          lookalike:
            lookalikeName && lookalikeRatio
              ? {
                  name: lookalikeName,
                  ratio: lookalikeRatio,
                }
              : undefined,
          // due to backwards compatibility for data display
          lookalike_ratio: lookalikeRatio,
          lookalike_name: lookalikeName,
          audience_type: "page_lookalike" as const,
        };
      case "page_engagers":
        return {
          ...base,
          description: ca.description || "",
          page_type: ca.page_type || "facebook",
          page_id: ca.page_id || "",
          page_name: ca.page_name || "",
          audience_type: "page_engagers" as const,
        };
      case "meta":
        return {
          ...base,
          description: ca.description || "",
          subtype: ca.subtype || "",
          time_created: ca.time_created,
          time_updated: ca.time_updated,
          data_source:
            ca.data_source?.type && ca.data_source?.sub_type
              ? {
                  type: ca.data_source.type,
                  sub_type: ca.data_source.sub_type,
                }
              : undefined,
          delivery_status:
            ca.delivery_status?.code !== undefined
              ? {
                  code: ca.delivery_status.code,
                  description: ca.delivery_status.description,
                }
              : undefined,
          approximate_count_lower_bound: ca.approximate_count_lower_bound,
          approximate_count_upper_bound: ca.approximate_count_upper_bound,
          audience_type: "meta" as const,
        };
      case "interests":
        return {
          ...base,
          audience_type: "interests" as const,
          interests: (ca.interests ?? []).map(
            (i: { key?: string; value?: string }) => ({
              key: String(i.key ?? ""),
              value: String(i.value ?? i.key ?? ""),
            })
          ),
          created_at: ca.created_at,
        };
      default:
        return {
          ...base,
          description: ca.description || "",
          file_key: ca.file_key || "",
          mapping: ca.mapping || [],
          schema_fields: ca.schema_fields || [],
          audience_type: "csv" as const,
        };
    }
  });
};
